import { Icon } from '@euler/components/Icomoon';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, ReactNode } from 'react';
import {
  StyleProp,
  Text,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { useTheme } from 'styled-components';

export const EmptyView = memo(
  ({
    noFullHeight,
    error,
    message,
    iconColor,
    iconSize,
    buttonText,
    showIcon = true,
    style,
    messageStyle,
    buttonStyle,
    buttonTextStyle,
    onRetry,
  }: {
    error?: Error;
    noFullHeight?: boolean;
    message?: ReactNode;
    iconColor?: string;
    iconSize?: number;
    buttonText?: string;
    style?: StyleProp<ViewStyle>;
    messageStyle?: StyleProp<TextStyle>;
    buttonStyle?: StyleProp<ViewStyle>;
    buttonTextStyle?: StyleProp<TextStyle>;
    showIcon?: boolean;
    onRetry?: () => void;
  }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    iconSize = iconSize ?? rpx(64);
    return (
      <View
        css={`
          align-items: center;
          justify-content: center;
        `}
        style={[noFullHeight ? {} : { flex: 1 }, style]}
      >
        {showIcon ? (
          error ? (
            <Icon
              name="error"
              size={iconSize}
              color={theme.colors.status.danger}
            />
          ) : (
            <Icon
              name="file-tray-outline"
              size={iconSize}
              color={iconColor ?? theme.components.emptyView.iconColor}
            />
          )
        ) : null}
        {message && typeof message === 'object' ? (
          message
        ) : (
          <Text
            css={`
              font-family: ${FontFamily.NotoSans.Light};
              font-size: ${rpx(15)}px;
              text-align: center;
              color: ${error
                ? theme.colors.status.danger
                : theme.components.emptyView.textColor};
              margin-top: ${rpx(showIcon ? 8 : 0)}px;
            `}
            style={messageStyle}
          >
            {message ??
              (error ? '对不起，服务暂时不可用，请稍后重试!' : '暂无相关数据')}
          </Text>
        )}
        {error && (
          <TouchableOpacity
            onPress={onRetry}
            style={buttonStyle}
            css={`
              background-color: ${theme.components.emptyView
                .retryButtonBgColor};
              height: ${rpx(28)}px;
              border-radius: ${rpx(14)}px;
              justify-content: center;
              align-items: center;
              margin-top: ${rpx(36)}px;
              padding: ${rpx(4)}px ${rpx(16)}px;
            `}
          >
            <Text
              style={buttonTextStyle}
              css={`
                font-family: ${FontFamily.NotoSans.Regular};
                font-size: ${rpx(13)}px;
                line-height: ${rpx(20)}px;
              `}
            >
              {buttonText ?? '重试'}
            </Text>
          </TouchableOpacity>
        )}
      </View>
    );
  },
);
